import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import { reportEvent } from '~/domains/analytics';

import { handleRefreshInterceptor } from '../interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '../interceptors/set-auth-token.interceptor';
import {
  GeoComplyReasonCode,
  GeoComplyTokenType,
  GeoErrorPolicy,
  Method,
  setLocationInterceptor,
} from '../interceptors/set-location.interceptor';

export const walletServiceInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_PAYMENTS_SERVICE}`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(walletServiceInstance);
handleRefreshInterceptor(walletServiceInstance);
setLocationInterceptor(walletServiceInstance, [
  [
    Method.GET,
    '/settings/available-payment-methods/deposit',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.VALID },
  ],
  [
    Method.POST,
    '/wallets/aeropay/confirm-user',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/aeropay/challenge',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/aeropay/link-account',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.VALID },
  ],
  [
    Method.POST,
    '/wallets/aeropay/deposits',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.DELETE,
    '/wallets/aeropay/account',
    { reasonCode: GeoComplyReasonCode.PAYMENT_METHOD_CHANGE, tokenType: GeoComplyTokenType.VALID },
  ],
  [
    Method.POST,
    '/wallets/cards',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/deposits',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/payment-handles/card',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/payment-handles/paypal',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/payment-handles/vip-preferred',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/payment-handles/skrill',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.POST,
    '/wallets/payment-handles/venmo',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.FRESH },
  ],
  [
    Method.GET,
    // A deposit-context READ that is polled every 5s during provisioning — mirrors the established
    // pattern (reads reuse a VALID token; value/disclosure POSTs force FRESH; precedent:
    // GET /settings/available-payment-methods/deposit). VALID reuses the persisted token while it is
    // ALLOWED and valid for >= LOCATION_TOKEN_MIN_VALIDITY_MS, so the poll does not force a new
    // GeoComply geolocation (and prompt) on every tick; the first call / near-expiry still fetch fresh.
    '/wallets/whop-crypto/addresses',
    { reasonCode: GeoComplyReasonCode.DEPOSIT, tokenType: GeoComplyTokenType.VALID },
  ],
  [
    Method.POST,
    '/wallets/withdrawals',
    {
      reasonCode: GeoComplyReasonCode.WITHDRAWAL,
      tokenType: GeoComplyTokenType.FRESH,
      requireOwnCheck: true,
      geoErrorPolicy: GeoErrorPolicy.SEND_RESTRICTED_LOCATION_TOKEN,
      onOutcome: (result) => reportEvent('withdrawal_geo_check', result),
    },
  ],
]);
